module.exports = __webpack_public_path__ + "img/GAME_HORSE.d87b0248.png";